import { useAuthStore } from "@/stores/auth";

/**
 * Get the current auth token from the Zustand store.
 * Use this in non-React contexts (service files, API modules).
 * For React components/hooks, prefer useAuthStore((s) => s.token).
 */
export function getToken(): string {
  return useAuthStore.getState().token ?? "";
}

/**
 * Get the current user from the Zustand store.
 * Returns the parsed user object or null.
 */
export function getCurrentUser() {
  return useAuthStore.getState().user;
}
